import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import FeatureModalContainer from '../../components/SetupSubPageComps/FeaturesComps/FeatureModalContainer';
import ShowAllFeatures from '../../components/SetupSubPageComps/FeaturesComps/ShowAllFeatures';
import FeatureProvider from '../../contexts/FeatureProvider';

const Features = () => {
  // rendering features page component here
  return (
    <>
      <PageTitle title='Features Setup' />

      <FeatureProvider>
        <ShowAllFeatures />
        <FeatureModalContainer />
      </FeatureProvider>
    </>
  );
};

export default Features;
